import { isNil, isValid } from "@visactor/vutils";

import { ChartEvent } from "../../../constant";

import { getPolarDimensionInfo } from "../../../event/events/dimension/util/polar";

import { getCartesianDimensionInfo } from "../../../event/events/dimension/util/cartesian";

import { isDiscrete } from "@visactor/vscale";

import { getTooltipSpecForShow } from "../utils/get-spec";

import { getShowContent } from "../utils/compose";

import { getTooltipPatternValue } from "../utils/get-value";

export class BaseTooltipProcessor {
    constructor(component) {
        this._showTooltipByHandler = (data, params) => {
            var _a, _b, _c;
            if (isNil(data)) return 1;
            params.changePositionOnly || this.clearCache(), this._updateViewSpec(params);
            const spec = this._cacheViewSpec;
            if (isNil(null == spec ? void 0 : spec[this.activeType]) || !1 === spec.visible) return 1;
            params.tooltipSpec = spec, this._updateActualTooltip(data, params), params.tooltipActual = this._cacheActualTooltip;
            const {title: title, content: content} = this._cacheActualTooltip, isEmpty = isNil(null == title ? void 0 : title.key) && isNil(null == title ? void 0 : title.value) && !(null == content ? void 0 : content.length);
            if (this.component.event.emit(ChartEvent.tooltipShow, Object.assign(Object.assign({}, params), {
                isEmptyTooltip: isNil(null == title ? void 0 : title.key) && isNil(null == title ? void 0 : title.value) && !(null == content ? void 0 : content.length),
                tooltipData: data,
                activeType: this.activeType,
                tooltip: this.component
            })), isEmpty) return 1;
            let showTooltip;
            return (null === (_a = spec.handler) || void 0 === _a ? void 0 : _a.showTooltip) ? showTooltip = spec.handler.showTooltip.bind(spec.handler) : (null === (_b = this.component.tooltipHandler) || void 0 === _b ? void 0 : _b.showTooltip) && (showTooltip = this.component.tooltipHandler.showTooltip.bind(this.component.tooltipHandler)), 
            showTooltip ? null !== (_c = showTooltip(this.activeType, data, params)) && void 0 !== _c ? _c : 0 : 1;
        }, this.component = component;
    }
    _preprocessDimensionInfo(dimensionInfo) {
        const newDimensionInfo = [];
        if (null == dimensionInfo || dimensionInfo.forEach((info => {
            const di = Object.assign(Object.assign({}, info), {
                data: info.data.filter((({series: series}) => {
                    var _a, _b;
                    return !1 !== (null === (_b = null === (_a = series.getSpec()) || void 0 === _a ? void 0 : _a.tooltip) || void 0 === _b ? void 0 : _b.visible);
                }))
            });
            di.data.length > 0 && newDimensionInfo.push(di);
        })), newDimensionInfo.length > 0) return newDimensionInfo;
    }
    _getDimensionInfo(params) {
        var _a, _b;
        let targetDimensionInfo;
        const chart = this.component.getChart(), layer = chart.getCompiler().getStage().getLayer(void 0), point = {
            x: params.event.viewX,
            y: params.event.viewY
        };
        if (layer.globalTransMatrix.transformPoint({
            x: params.event.viewX,
            y: params.event.viewY
        }, point), targetDimensionInfo = [ ...null !== (_a = getCartesianDimensionInfo(chart, point, !0)) && void 0 !== _a ? _a : [], ...null !== (_b = getPolarDimensionInfo(chart, point)) && void 0 !== _b ? _b : [] ], 
        0 === targetDimensionInfo.length) targetDimensionInfo = void 0; else if (targetDimensionInfo.length > 1) {
            const dimensionAxisInfo = targetDimensionInfo.filter((info => {
                var _a;
                const axis = info.axis;
                if (axis.getSpec().hasDimensionTooltip) return !0;
                if (!isDiscrete(axis.getScale().type)) return !1;
                let firstSeries;
                for (const region of null !== (_a = null == axis ? void 0 : axis.getRegions()) && void 0 !== _a ? _a : []) {
                    for (const series of region.getSeries()) if ("cartesian" === series.coordinate) {
                        firstSeries = series;
                        break;
                    }
                    if (isValid(firstSeries)) break;
                }
                return isValid(firstSeries) && firstSeries.getDimensionField()[0] === firstSeries.fieldY[0] ? "left" === axis.getOrient() || "right" === axis.getOrient() : "bottom" === axis.getOrient() || "top" === axis.getOrient();
            }));
            if (targetDimensionInfo = dimensionAxisInfo.length ? dimensionAxisInfo : targetDimensionInfo.slice(0, 1), 
            targetDimensionInfo.length > 1) {
                const dimensionDataKeySet = new Set;
                targetDimensionInfo.forEach((info => {
                    info.data = info.data.filter((({key: key}) => !dimensionDataKeySet.has(key) && (dimensionDataKeySet.add(key), 
                    !0)));
                }));
            }
        }
        return targetDimensionInfo;
    }
    _updateViewSpec(params) {
        const {changePositionOnly: changePositionOnly, model: model, dimensionInfo: dimensionInfo} = params;
        changePositionOnly && this._cacheViewSpec || (this._cacheViewSpec = getTooltipSpecForShow(this.activeType, this.component.getSpec(), model, dimensionInfo));
    }
    _updateActualTooltip(data, params) {
        var _a, _b, _c, _d;
        const pattern = this._cacheViewSpec[this.activeType], {changePositionOnly: changePositionOnly} = params;
        if (!changePositionOnly || !this._cacheActualTooltip) {
            const tooltipContent = getShowContent(pattern, data, params), visible = !!isValid(tooltipContent) && !1 !== getTooltipPatternValue(pattern.visible, data, params);
            this._cacheActualTooltip = Object.assign(Object.assign({}, tooltipContent), {
                visible: visible,
                activeType: pattern.activeType,
                data: data
            });
            const {title: title, content: content} = this._cacheActualTooltip;
            this._cacheActualTooltip.title = null !== (_b = null === (_a = pattern.updateTitle) || void 0 === _a ? void 0 : _a.call(pattern, title, data, params)) && void 0 !== _b ? _b : title, 
            this._cacheActualTooltip.content = null !== (_d = null === (_c = pattern.updateContent) || void 0 === _c ? void 0 : _c.call(pattern, content, data, params)) && void 0 !== _d ? _d : content;
        }
    }
    clearCache() {
        this._cacheViewSpec = void 0, this._cacheActualTooltip = void 0;
    }
}
//# sourceMappingURL=base.js.map
